module.exports = __webpack_public_path__ + "static/media/menu-final.0678113d.svg";